import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import JanelasCard from './components/JanelasCard';

const DescargaJanelaMain = () => (
  <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[
            { name: 'Inicio' },
            { name: 'Descarga' },
            { name: 'Janela Descarga' }
          ]}
        />
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <JanelasCard />
      </Col>
    </Row>
  </Container>
);

export default DescargaJanelaMain;
